import React from "react";
import {Modal} from "antd";
import {ExclamationCircleFilled} from "@ant-design/icons";
import {useFetch} from "../../../../hooks/useFetch";
import {useStore} from "../../../../hooks/useStore";

const TransferCenterConfirmModal = ({
    isOpenConfirmModal,
    onCloseConfirmModal,
    actionType,
    transferCenterId,
    refetchTransferCenterList
}) => {
    const stores = useStore();
    const [transferCenterLoading, transferCenterUpdate, , , refetch] = useFetch({
        fetchFn: () =>
            stores.transferStore.updateTransferCenterStatus({
                transferCenterId,
                status: actionType
            }),
        dependencies: [],
        initialCall: false,
        callbackFunc: () => {
            onCloseConfirmModal();
            refetchTransferCenterList();
        }
    });

    const handleConfirm = () => {
        refetch();
    };

    return (
        <Modal
            visible={isOpenConfirmModal}
            onCancel={onCloseConfirmModal}
            onOk={() => handleConfirm()}
            okText={actionType === "active" ? "Onayla" : "Reddet"}
            cancelText="İptal"
            confirmLoading={transferCenterLoading}
        >
            <ExclamationCircleFilled
                style={{
                    color: "orange",
                    fontSize: 24,
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: "30px"
                }}
            />
            <h3 style={{display: "flex", justifyContent: "center"}}>
                {actionType === "active"
                    ? "Onaylamak istediğinize emin misiniz?"
                    : "Reddetmek istediğinize emin misiniz?"}
            </h3>
        </Modal>
    );
};

export default TransferCenterConfirmModal;
